import { SkillCategoryModel } from '@/apiTypes/SkillsTypes';
import { BuildType } from './ApiService';

export const skillCategoryApiEndpoints = (build: BuildType) => ({
    getSkillCategories: build.query<SkillCategoryModel[], void>({
        query: () => 'skill-categories',
        transformResponse: (response: SkillCategoryModel[]) => response,
    }),
});
